import * as React from "react";

import type { IconProps } from "./types";

export const RecoveryWheelIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={forwardedRef}
    >
      <rect x="3.5" y="0.5" width="9" height="15" rx="1" stroke={color} />
      <rect x="5.5" y="2.5" width="5" height="11" stroke={color} />
      <path d="M5.5 4.5H10.5M5.5 6H10.5M5.5 10H10.5M5.5 11.5H10.5" stroke={color} strokeWidth="0.75" />
      <rect x="2" y="7.25" width="12" height="1.5" fill={color} />
    </svg>
  ),
);

export default RecoveryWheelIcon;
